// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  align-items: stretch;
  width: 50%;
  min-width: 640px;
  border-radius: 2px;
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1);
}
@media (max-width: 768px) {
  :host {
    min-width: 90vw;
    width: 90vw;
  }
}
:host .teamBadge,
:host .playerBadge {
  flex: 0 0 24px;
  height: 24px;
  width: 24px;
  margin: 4px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  background-color: #FFF;
}
:host .teamBadge .photo,
:host .playerBadge .photo {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  border-radius: 50%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
}
:host .teamBadge .initials,
:host .playerBadge .initials {
  font-weight: 300;
  font-family: "RM Neue";
  font-size: 14px;
  line-height: 14px;
  z-index: 0;
}
:host .playerBadge {
  border: 1px solid #AEB1B9;
  border-radius: 50%;
  margin-left: -12px;
  margin-right: 8px;
}
@media (max-width: 768px) {
  :host .playerBadge {
    display: none;
  }
}
:host .teamBadge {
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
@media (max-width: 768px) {
  :host .teamBadge {
    display: none;
  }
}
:host p {
  font-size: 12px;
  line-height: 16px;
  color: #1A1E29;
  display: flex;
  align-items: center;
  padding: 8px;
}
:host p > * {
  margin-right: 4px;
}
:host p .team {
  color: #AEB1B9;
}
:host p .result {
  font-weight: 700;
  font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  color: #3D923D;
}
:host p .result.missed {
  color: #9397A2;
}
:host p .time {
  margin-right: 12px;
}
:host p .score {
  font-weight: 700;
  font-family: "RM Neue";
  font-size: 16px;
  line-height: 16px;
  color: #1A1E29;
}
:host p .score .changed {
  color: #3D923D;
}
:host p:first-of-type {
  flex: 1 1 auto;
}
:host p + p {
  border-left: 1px solid #E4E5E8;
  flex: 0 0 138px;
  justify-content: flex-end;
}
@media (max-width: 768px) {
  :host p {
    flex-direction: row;
    flex-wrap: wrap;
  }
  :host p .title {
    flex: 1 1 100%;
  }
  :host p .assist {
    display: none;
  }
  :host p .time, :host p .score {
    margin-right: 0;
  }
  :host p + p {
    flex: 0 0 80px;
    align-items: center;
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/map/event-message/event-message.component.scss","webpack://./src/theme.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,oBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,0CAAA;EACA,yCAAA;AADF;AAGE;EATF;IAUI,eAAA;IACA,WAAA;EAAF;AACF;AAEE;;EAEE,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EAEE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,sBCVO;ADSb;AAGM;;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,2BAAA;EACA,4BAAA;EACA,UAAA;AAAR;AAGM;;ECcF,gBAAA;EAYA,sBAAA;EDxBI,eAAA;EACA,iBAAA;EACA,UAAA;AACR;AAGE;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AADJ;AAGI;EANF;IAOI,aAAA;EAAJ;AACF;AAGE;EACE,wBAAA;EACA,2BAAA;EACA,4BAAA;AADJ;AAGI;EALF;IAMI,aAAA;EAAJ;AACF;AAGE;EACE,eAAA;EACA,iBAAA;EACA,cCpEQ;EDqER,aAAA;EACA,mBAAA;EACA,YAAA;AADJ;AAGI;EACE,iBAAA;AADN;AAII;EACE,cCvEK;ADqEX;AAKI;ECzBA,gBAAA;EAQA,+DAAA;EDmBE,cC1DM;ADwDZ;AAIM;EACE,cChFG;AD8EX;AAMI;EACE,kBAAA;AAJN;AAOI;ECtCA,gBAAA;EAMA,sBAAA;EDkCE,eAAA;EACA,iBAAA;EACA,cClGM;AD8FZ;AAMM;EACE,cC5EI;ADwEZ;AAQI;EACE,cAAA;AANN;AASI;EACE,8BAAA;EACA,eAAA;EACA,yBAAA;AAPN;AAUI;EAlDF;IAmDI,mBAAA;IACA,eAAA;EAPJ;EASI;IACE,cAAA;EAPN;EAUI;IACE,aAAA;EARN;EAWI;IACE,eAAA;EATN;EAYI;IACE,cAAA;IACA,mBAAA;IACA,uBAAA;EAVN;AACF","sourcesContent":["@import 'theme';\n\n:host {\n  display: flex;\n  align-items: stretch;\n  width: 50%;\n  min-width: 640px;\n  border-radius: 2px;\n  background-color: transparentize($colorWhite, .1);\n  box-shadow: 0 0 12px 0 transparentize($colorBlack, .9);\n\n  @media (max-width: $mobileBreakpoint) {\n    min-width: 90vw;\n    width: 90vw;\n  }\n  \n  .teamBadge,\n  .playerBadge {\n    flex: 0 0 24px;\n    height: 24px;\n    width: 24px;\n    margin: 4px;\n\n      position: relative;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      vertical-align: middle;\n      background-color: $colorWhite;\n\n      .photo {\n        position: absolute;\n        top: 0;\n        left: 0;\n        height: 100%;\n        width: 100%;\n        border-radius: 50%;\n        background-size: contain;\n        background-position: center;\n        background-repeat: no-repeat;\n        z-index: 1;\n      }\n  \n      .initials {\n        @include font(light, condensed);\n        font-size: 14px;\n        line-height: 14px;\n        z-index: 0;\n      }\n  }\n\n  .playerBadge {\n    border: 1px solid $colorN30;\n    border-radius: 50%;\n    margin-left: -12px;\n    margin-right: 8px;\n\n    @media (max-width: $mobileBreakpoint) {\n      display: none;\n    }\n  }\n\n  .teamBadge {\n    background-size: contain;\n    background-position: center;\n    background-repeat: no-repeat;\n\n    @media (max-width: $mobileBreakpoint) {\n      display: none;\n    }\n  }\n\n  p {\n    font-size: 12px;\n    line-height: 16px;\n    color: $colorN100;\n    display: flex;\n    align-items: center;\n    padding: 8px;\n\n    & > * {\n      margin-right: 4px;\n    }\n    \n    .team {\n      color: $colorN30;\n    }\n\n    .result {\n      @include font(bold);\n      color: $colorLive;\n\n      &.missed {\n        color: $colorN40;\n      }\n    }\n\n    .time {\n      margin-right: 12px;\n    }\n\n    .score {\n      @include font(bold, condensed);\n      font-size: 16px;\n      line-height: 16px;\n      color: $colorN100;\n\n      .changed {\n        color: $colorLive;\n      }\n    }\n    \n    &:first-of-type {\n      flex: 1 1 auto;\n    }\n    \n    & + p {\n      border-left: 1px solid $colorN10;\n      flex: 0 0 138px;\n      justify-content: flex-end;\n    }\n\n    @media (max-width: $mobileBreakpoint) {\n      flex-direction: row;\n      flex-wrap: wrap;\n\n      .title {\n        flex: 1 1 100%;\n      }\n\n      .assist {\n        display: none;\n      }\n\n      .time, .score {\n        margin-right: 0;\n      }\n\n      & + p {\n        flex: 0 0 80px;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n  }\n}","$colorPrimary: #3E31FA;\n$colorPrimaryBg: #EEF2FD;\n$colorAccent: #1785FB;\n$colorSecondary: #C8B17B;\n\n$colorAdsBG: #0D0D0D;\n$colorBlack: #000;\n$colorN100: #1A1E29;\n$colorN90: #292D3A;\n$colorN80: #383D4C;\n$colorN70: #4B505F;\n$colorN60: #626775;\n$colorN50: #787D8B;\n$colorN40: #9397A2;\n$colorN30: #AEB1B9;\n$colorN20: #C9CBD1;\n$colorN10: #E4E5E8;\n$colorN05: #F2F2F4;\n$colorWhite: #FFF;\n\n$colorBestPlayer: #F2B701;\n$colorDisabled: $colorN30;\n\n$gridRampComp1: #FFFFFF;\n$gridRampComp2: #FFFFCC;\n$gridRampComp3: #A1DAB4;\n$gridRampComp4: #41B6C4;\n$gridRampComp5: #2C7FB8;\n$gridRampComp6: #253494;\n\n$colorGood: #A2D98C;\n$colorBad: #E73F74;\n$colorLive: #3D923D;\n$colorLiveTooltip: #A2D98C;\n\n$colorNotFound: #DC0032;\n$colorBackgroundTooltip: #0F2145;\n\n$colorGreyPlacehold: #8C95A6;\n$colorGreyTitle: #0F2145;\n$colorGreyLabel: #5E6A83;\n$colorGreyDark: #29395A;\n$colorGreyOffWhite: #FBFDFF;\n$colorGreyOffBlack: #14142B;\n$animationTimeSlow: 2s;\n$animationTimeNormal: 1s;\n$animationTimeFast: .5s;\n$animationTimeBlink: .1s;\n$animationFuncDefault: ease-out;\n$animationFuncAlt: linear;\n\n$mobileBreakpoint: 768px;\n\n@mixin font($weight: normal, $condensed: false) {\n  @if $weight == extra-light {\n    font-weight: 200;\n  } @else if $weight == light {\n    font-weight: 300;\n  } @else if $weight == normal {\n    font-weight: 400;\n  } @else if $weight == medium {\n    font-weight: 500;\n  } @else if $weight == bold {\n    font-weight: 700;\n  } @else if $weight == black {\n    font-weight: 900;\n  }\n\n  @if $condensed == condensed {\n    font-family: 'RM Neue';\n  } @else {\n    font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\n  }\n}\n\n@mixin pseudoElemIcon($file, $height, $width) {\n  content: '';\n  display: inline-block;\n  height: $height;\n  width: $width;\n  background-image: url($file);\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n@mixin noselect() {\n  -webkit-touch-callout: none;\n    -webkit-user-select: none;\n     -khtml-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n@mixin button($file: null) {\n  border: none;\n  cursor: pointer;\n  display: flex;\n  padding: 12px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  border-radius: 12px;\n  background: linear-gradient(8deg, #3E31FA 19.1%, #8760F6 94.27%);\n  color: $colorGreyOffWhite;\n  @include font(medium);\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n\n  @if $file != null {\n    &::before {\n      @include pseudoElemIcon($file, 16px, 16px);\n    }\n  }\n}\n\n@mixin headingH3() {\n  @include font(bold);\n  font-size: 32px;\n  font-style: normal;\n  letter-spacing: -0.5px;\n  margin-bottom:16px;\n  color: $colorGreyOffBlack;\n  text-align: center;\n}\n@mixin headingH5() {\n  @include font(normal);\n  font-size: 24px;\n  font-style: normal;\n  letter-spacing: -0.5px;\n  margin-bottom:16px;\n  color: $colorGreyDark;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
